<app-header></app-header>

<mat-sidenav-container class="nav-container">
<!--  <mat-sidenav mode="side" opened>-->
<!--    <app-sidebar></app-sidebar>-->
<!--  </mat-sidenav>-->
  <mat-sidenav-content>
    <div class="main-container">
      <div class="content">
        <router-outlet ></router-outlet>
      </div>
      <app-footer-logged></app-footer-logged>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

